import styled from 'styled-components';

export default styled.div`
  &:not(:first-child) {
    margin: 12px 0 0 0;
  }
`;
